"use client";

import IdeaValidator from "@/components/IdeaValidator";
import { usePathname } from "next/navigation";

export default function GlobalValidatorWrapper() {
    const pathname = usePathname();

    // Do not show on AI Validator pages, Career pages AND Admin pages
    if (pathname.startsWith("/ai-validator") || pathname.startsWith("/careers") || pathname.startsWith("/admin")) {
        return null;
    }

    const isHomePage = pathname === "/";
    // If not home page, show immediately (threshold -1), otherwise wait for scroll (default 300)
    const threshold = isHomePage ? 300 : -1;

    // Render ONLY the sticky version
    return <IdeaValidator mode="sticky" scrollThreshold={threshold} className="" />;
}
